import React from 'react';
import CheckList from '../../../../Elements/CheckList';
import MetricTiles from '../../../../Elements/MetricTiles';
import CheckListToneEnum from '../../../../Enums/CheckListToneEnum';
import { formatMonthLabel } from '../../../../Helpers/invoiceAutomationMonthHelper';
import { getRunResultHeadline, getRunResultTiles } from '../../../../Helpers/invoiceAutomationRunHelper';
import InvoiceAutomationJobId from './InvoiceAutomationJobId';
import InvoiceAutomationRemovedJobs from './InvoiceAutomationRemovedJobs';

// What a run of automatic invoicing did: whether it is done, stopped on an error or never started, its counts in the
// preview's tiles, the months out of scope because their drafts were cancelled, and the jobs it took off its drafts
// and could not add, with the reasons it recorded.
export default function InvoiceAutomationRunResult({ result = null, skippedJobs = [], removedJobs = [] }) {
  if (result === null) {
    return null;
  }

  const cancelledMonthLabels = (result.cancelledMonths ?? []).map((month) => formatMonthLabel(month)).join(', ');
  const skippedJobItems = skippedJobs.map((job) => ({
    tone: CheckListToneEnum.Warn,
    text: (
      <>
        Job{' '}
        <InvoiceAutomationJobId
          tpJobId={job.tpJobId}
          thirdPartyJobId={job.thirdPartyJobId}
        />
        : {job.reason}
      </>
    ),
  }));
  return (
    <div className='iauto-run'>
      <div className='iauto-run-lead'>
        <b>{getRunResultHeadline(result)}</b>
        {result.message && <span>{result.message}</span>}
      </div>
      {result.invoiceAutomationRunId && <MetricTiles tiles={getRunResultTiles(result)} />}
      {cancelledMonthLabels && (
        <CheckList
          items={[
            {
              tone: CheckListToneEnum.Info,
              text: `Out of scope because their drafts were cancelled: ${cancelledMonthLabels}.`,
            },
          ]}
        />
      )}
      <InvoiceAutomationRemovedJobs
        title='The jobs it removed'
        lead='They no longer passed the Ready for Invoicing rules. Once they are ready again, a later run adds them back.'
        jobs={removedJobs}
      />
      {skippedJobItems.length > 0 && (
        <section className='iauto-run-section'>
          <h4>The jobs it could not add</h4>
          <CheckList items={skippedJobItems} />
        </section>
      )}
    </div>
  );
}
